import { TieredMenu } from "primereact/tieredmenu";
import React, { useEffect, useRef, useState } from "react";
import { Col, Row } from "react-bootstrap";
import { BsThreeDotsVertical } from "react-icons/bs";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import CorporateCard from "../../components/CorporateCard";
import Loader from "../../components/Loader";
import PaddingContainer from "../../components/PaddingContainer";
import { CouponBlackIcon, Pencil, Trash } from "../../constant";
import AreYouSureModal from "../../modals/AreYouSureModal";
import AddOrEditCouponsModal from "../../modals/Coupons/AddOrEditCouponsModal";
import useApi from "../../useApi";
import classes from "./Corporates.module.css";
import Button from "../../components/Button";
import { AddCircleIcon } from "../../constant";
import { setPageTitle, setPageLink } from "../../store/pageSlice";
import { useDispatch } from "react-redux";
import Title from "../../components/Title";
const Corporate = () => {
  const dispatch = useDispatch();
  const menu = useRef(null);
  const navigate = useNavigate();
  const api = useApi();
  const [selectedItem, setSelectedItem] = useState(null);
  const [menuItems, setMenuItems] = useState([]);
  const [showAddOrEditCouponModal, setShowAddOrEditCouponModal] =
    useState(false);
  const [loading, setLoading] = useState(false);
  const [showAreYouSureModal, setShowAreYouSureModal] = useState(false);
  const [corporateList, setCorporateList] = useState([]);

  useEffect(() => {
    if (selectedItem) {
      const hasExistingCoupons = selectedItem?.corporateCoupons?.length > 0;

      const newMenuItems = [
        {
          label: "Add Coupon",
          icon: <CouponBlackIcon className={classes.icon} />,
          command: () => setShowAddOrEditCouponModal(true),
        },
        {
          label: "Edit Corporate",
          icon: <Pencil className={classes.icon} />,
          command: () =>
            navigate(
              `/corporates/edit-corporate/${selectedItem?.corporateId}`,
              {
                state: selectedItem,
              }
            ),
        },
        {
          label: "Delete Corporate",
          icon: <Trash className={classes.icon} />,
          command: () => {
            setShowAreYouSureModal(true);
          },
        },
      ];

      setMenuItems(newMenuItems);
    }
  }, [selectedItem]);

  const getAllCorporate = async (params) => {
    setLoading(true);
    const res = await api.getAllCorporates(params);
    if (res.data?.headers?.error === 200) {
      console.log("res?.data?.body?.items", res.data?.body);
      setCorporateList(res.data?.body?.items);
    }
    setLoading(false);
  };

  const addCorporateCoupon = async (params) => {
    const res = await api.addCorporateCoupon(params);
    if (res.data?.headers?.error === 200) {
      console.log("res?.data?.body?.items", res.data?.body);
      const id = selectedItem?.corporateId;
      if (id) {
        setCorporateList((prev) => {
          const list = [...prev];
          const index = list.findIndex((item) => item?.corporateId === id);
          if (index !== -1) {
            list[index] = {
              ...list?.[index],
              corporateCoupons: [
                ...list?.[index]?.corporateCoupons,
                res.data?.body,
              ],
            };
          }
          console.log("updateList", list);
          return list;
        });
      }
      toast.success("Corporate Coupon Added Successfully");
      setShowAddOrEditCouponModal(false);
      return true;
    } else {
      toast.error(res.data?.headers?.message);
    }
  };

  const updateOrDeleteCoupon = async (params, index) => {
    console.log("Params of updateOrDeleteCoupon", params);
    const res = await api.updateCoupon(params);
    if (res.data?.headers?.error === 200) {
      toast.success(
        `${params?.delete ? "Coupon Deleted" : "Coupon Updated"} Successfully`
      );

      if (params?.delete) {
        setCorporateList((prev) => {
          const list = [...prev];
          list[index] = {
            ...list?.[index],
            corporateCoupons: [
              ...list?.[index]?.corporateCoupons?.filter(
                (item) => item?.couponId !== params?.couponId
              ),
            ],
          };
          console.log("list", list);
          return list;
        });
      } else {
        setCorporateList((prev) => {
          const list = [...prev];
          list[index] = {
            ...list?.[index],
            corporateCoupons: [
              ...list?.[index]?.corporateCoupons?.map((item) =>
                item?.couponId === params?.couponId ? params : item
              ),
            ],
          };
          console.log("list", list);
          return list;
        });
      }
    } else {
      toast.error(res.data?.headers?.message);
    }
  };
  const deleteCorporateApi = async (params) => {
    const res = await api.updateCorporate(params);
    if (res.data?.headers?.error === 200) {
      toast.success("Corporate Deleted Successfully");
      setShowAreYouSureModal(false);
      setCorporateList((prev) => {
        const list = [...prev];
        return list.filter((item) => item?.corporateId !== params?.corporateId);
      });
    } else {
      toast.error(res.data?.headers?.message);
    }
  };

  useEffect(() => {
    getAllCorporate({
      id: null,
      search: "",
      pageNumber: 1,
      pageSize: 10,
      showInactive: false,
      showUpcoming: true,
    });
  }, []);

  useEffect(() => {
    // Set page title and navigation
    dispatch(setPageTitle("Corporates"));
    dispatch(setPageLink(""));
  }, []);
  return (
    <>
      {loading ? (
        <Loader />
      ) : (
        <>
          <PaddingContainer
            // heading={"List of Corporates Onboarded"}
            style={{ height: "calc(100% - 105px)" }}
          >
            <header className={classes.header}>
              <Title title={"List of Corporates Onboarded"} />
              <Button
                leftIcon={<AddCircleIcon />}
                label="Add Corporate"
                onClick={() => {
                  navigate("/corporates/add-corporates");
                }}
                className={classes.addCorporateButton}
              />
            </header>
            <section className={classes.cardsGrid}>
              <h2 className={classes.title}>Recently Added</h2>
              <Row className={classes.grid}>
                <Col xs={12}>
                  
                </Col>
                {corporateList?.map((cd, index) => (
                  <Col lg={6} md={6} key={cd?.id}>
                    <CorporateCard
                      index={index}
                      data={cd}
                      menu={
                        <>
                          <span
                            onClick={(e) => {
                              setSelectedItem(cd);
                              menu.current.toggle(e);
                            }}
                          >
                            <BsThreeDotsVertical size={20} />
                          </span>
                          <TieredMenu
                            model={menuItems}
                            popup
                            ref={menu}
                            breakpoint="767px"
                          />
                        </>
                      }
                      updateOrDeleteCoupon={updateOrDeleteCoupon}
                    />
                  </Col>
                ))}
              </Row>
            </section>
          </PaddingContainer>

          {showAddOrEditCouponModal && (
            <AddOrEditCouponsModal
              show={showAddOrEditCouponModal}
              setShow={setShowAddOrEditCouponModal}
              onSubmit={addCorporateCoupon}
              additionalParams={selectedItem}
            />
          )}

          {showAreYouSureModal && (
            <AreYouSureModal
              title={"Corporate"}
              show={showAreYouSureModal}
              setShow={setShowAreYouSureModal}
              onConfirm={() =>
                deleteCorporateApi({
                  corporateId: selectedItem?.corporateId,
                  corporateLogo: null,
                  corporateType: null,
                  corporateCountryCode: null,
                  corporateCellNumber: null,
                  corporateEmail: null,
                  corporateAddress: null,
                  corporateCity: null,
                  corporateState: null,
                  corporateCountry: null,
                  delete: true,
                })
              }
            />
          )}
        </>
      )}
    </>
  );
};

export default Corporate;
